export class Demo {
  constructor(
    public id: string,
    public type: number,
    public status: number,
    public date_add: number,
    public credentials: any
  ) {}
}